<template>
    <div class="post_d box_shadow" :style="{height:tops}">
        <div class="comments-box" @scroll.passive="handleScroll($event)">
            <div class="comments-head">
                <div class="comments-number">回復&nbsp;&nbsp;<span class="number">{{commentNumber}}</span></div>
            </div>
            <div class="comments-body">
                <div class="comment-item" v-for="(item,index) in comments" :key="index">
                    <div class="comment-replay">
                    <div class="left">
                        <div class="content">{{item.content}}</div>
                        <div class="player">
                            <div class="comment-avatar">
                                <!-- <img :src="item.avatar || defaultPlayerSrc" alt="" width="33" height="33"> -->
                                <img :src="item.user.avatar || defaultPlayerSrc" alt="" v-if="item.user.role_name !== '管理员'" width="33"
                                    height="33">
                                <img :src="item.user.avatar || defaultAdminSrc" alt="" v-if="item.user.role_name == '管理员'" width="33"
                                    height="33">
                            </div>
                            <div class="comment-content">
                                <div class="meta">
                                    <span class="name">{{item.user.role_name}}</span>
                                    <span class="name"><span v-show="item.user.role_name !== '管理员'">( {{item.user.sname}} )</span></span>
                                </div>
                                <!-- <div class="content">{{item.content}}</div> -->
                                <div class="reply-stat">
                                    <span style="color: #8a9aa9;">{{item.created_at}}</span>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="right em_all_icon">
                        <div class="action-box">
                            <div class="like-btn" @click="toggleLike(item)" :class="{'current':item.is_liked}">
                                <em class="like"></em>&nbsp;<i>{{item.like_count}}</i>
                            </div>
                            <div class="comment-btn" v-on:click="loadReplies(item)">
                                <em class="chat"></em>&nbsp;<i>{{item.reply_count}}</i>
                            </div>
                            <div class="inform-btn box_shadow" v-on:click="handleCommentInform(item.id)">
                                舉報
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="replies-box">
                        <post-replies :commentId="item.id" :active="item.active"></post-replies>
                    </div>
                </div>
            </div>
        </div>
        <div class="comments-footer">
            <input type="text" v-model="commentText" placeholder="寫下您的評論..." ref="postComments">
            <button @click="addComment">評論</button>
        </div>
        <loading v-show="isLoading"></loading>
    </div>
</template>
<script>
    import Vue from 'vue'
    import Loading from '@/views/Loading'
    import PostReplies from '@/components/Replies.vue'

    export default {
        name: 'DetailBot',
        props: {
            topicId: Number,
            commentNumber: Number
        },
        components: {
            Loading,
            PostReplies
        },
        data() {
            return {
                pos: 'fixed',
                docHeights: 0,
                comments: [],
                commentText: '',
                current_page: '',
                last_page: '',
                isMask: false,
                defaultPlayerSrc: '../../img/people.png',
                defaultAdminSrc: '../../img/admin.png',
                isLoading: false,
                comment_id: '',
                isFocus: false,
                tops:'100%'
            }
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo
            }
        },
        watch: {
            topicId(value) {
                if (value) {
                    console.log("wacth监听数据存在啊");
                    this.loadComments(1);
                }
            }
        },
        mounted() {
            this.handleScroll();
        },
        methods: {
            closePostFrom() {
                this.isMask = false
            },
            handleCommentInform(id) {
                this.$emit('handleCommentInform',id);
                this.comment_id = id;
            },
            returnUpperLevel() {
                this.$router.go(-1)
            },
            async addComment() {
                if (!this.commentText) {
                    return;
                }
                this.isLoading = true;
                let newComment = {
                    app_user_id: this.userInfo.app_user_id,
                    content: this.commentText,
                    topic_id: this.topicId,
                }
                let {data} = await this.$http.post('/comment/store', newComment);
                this.commentText = '';
                newComment.user = {};
                newComment.id = data.comment_id;
                newComment.created_at = '刚刚';
                newComment.user.avatar = this.userInfo.avatar;
                newComment.user.role_name = this.userInfo.role_name;
                newComment.user.sname = this.userInfo.sname;
                newComment.reply_count = 0;
                newComment.like_count = 0;
                this.comments.unshift(newComment);
                this.isLoading = false;

                var topic_id = this.$route.params.id;
                var api = `https://forum.gamemorefun.net/api/comment/${topic_id}/popNotice`
                this.$http
                    .get(api)
                    .then((result) => {
                        // console.log(result.data);
                    }).catch((error) => {
                        // console.log(error.response);
                    })
            },
            loadComments(page) {
                let api = '/comment/get';
                let params = {
                    page: page,
                    topic_id: this.topicId,
                    app_user_id: this.userInfo.app_user_id
                };
                this.$http
                    .get(api, {params: params})
                    .then(response => {
                        this.comments.push(...response.data.data);
                        let arr = response.data.data;
                        this.last_page = response.data.last_page;
                        this.current_page = response.data.current_page;
                    })
            },
            loadReplies(comment) {
                Vue.set(comment, 'active', !comment.active);
            },
            toggleLike(comment) {
                comment.is_liked = !comment.is_liked;
                if (comment.is_liked) {
                    comment.like_count++;
                } else {
                    // 点赞总数不能小于0
                    if (comment.like_count > 0) {
                        comment.like_count--;
                    }
                }
                this.$http
                    .post('/comment/like', {
                        'comment_id': comment.id,
                        'app_user_id': this.userInfo.app_user_id
                    })
            },
            handleScroll() {
                // 监听滚动事件,滚动到底部的时候加载分页数据
                window.onscroll = () => {
                    const el = document.documentElement;
                    if (el.scrollTop + el.offsetHeight === el.scrollHeight) {
                        // 还没有到最后一页才执行数据请求操作
                        if (this.current_page < this.last_page) {
                            this.current_page++;
                            this.loadComments(this.current_page);
                        }
                    }
                };
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @media all and (orientation: landscape)
        .post_d {
            width 100%
            height: 100% !important
            min-height: calc(100% + 1px)
            margin: 2vh auto 14vh
        }
        .player{
            width 100%
            display flex
        }
        .inform-btn {
            width: .9rem;
            height: .4rem;
            line-height: .4rem;
            color: #fe8124;
            border: 1px solid #fe8124;
            text-align: center;
            font-size: .245rem;
            vertical-align: middle;
            border-radius: 4px;
        }

        .like-btn em {
            margin-right:0
        }

        .comment-item {
            color: white;
            margin-bottom: 0.333rem;
            border-bottom: 1px solid #cccccc;
        }
        
        .comment-replay{
            display flex
            width 100%
        }

        .replies-box{
            width 96%
            float right
            padding 10px 0
        }

        .comment-item .left{
            flex:2.6
        }

        .comment-item .right{
            vertical-align: middle;
            display: flex;
            flex:.6;
            flex-direction: column;
            justify-content: center;
            justify-items: center;
        }

        .comment-item .content {
            color:#4c4c4c;
            font-size: .28rem;
            margin:0 auto .27rem
        }

        .comments-head {
            font-size .28rem;
            color: #666666;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 10px;
            text-align: right;
            border-bottom: 1px solid #cccccc;
        }
        .comments-body{
            width: 100%;
            height: 100%;
            padding-bottom: 5%;
            overflow-y: auto;
            display: block;
        }
        .comments-number{
            width: 1.16rem;
            height: 100%;
            padding: 10px 0;
            color: #666666;
            font-size: .28rem;
            border-bottom: 2px solid #fe8124;
        }

        .comments-box {
            margin: 0 0.1rem 0.1rem 0.1rem;
        }

        .meta {
            color:#4c4c4c;
            font-size: 0.28rem;
        }


        .comment-avatar,.comment-avatar>img {
            width: .59rem;
            height: .59rem;
        }

        .comment-avatar img {
            border-radius: 100%
        }

        .content {
            margin-top: 0.15rem;
            font-size: 0.25rem;
            line-height: 0.3rem;
            word-wrap: break-word;
            white-space: pre-wrap;
            word-break: break-all;
        }

        .reply-stat .time {
            display: inline-block;
            float: right;
        }

        .comment-content {
            padding-left: 10px;
            flex: 1 1 auto;
        }

        .comment-content .meta .name {
            font-size .3rem
            color #333333
            display inline-block
            margin-right 1vw
        }

        .reply-stat {
            display: flex;
            margin: 0.2rem 0;
            font-weight: 400;
        }

        .action-box {
            width: 100%;
            flex: 0 0 auto;
            display: flex;
            justify-content: space-between;
            margin-left: auto;
            min-width: 2.8rem;
            color:#666666;
            font-size: .24rem
        }

        .action-box > div{
            cursor pointer
        }

        .comments-footer {
            position: fixed;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            bottom: 0;
            width: 85%;
            height: .8rem;
            background: #d6d6d6;
            margin-left:0;
            z-index: 0;
        }

        .comments-footer input {
            height: 100%;
            line-height: 100%;
            border-radius: 3px;
            padding-left: 10px;
            font-size:.3rem;
            color: #4c4c4c;
            background: #d6d6d6;
            outline: none;
            min-height: 0.3em;
            flex: 1;
            margin-right: 20px;
        }

        .comments-footer button {
            width: 1.6rem;
            height: 100%;
            line-height: 35px;
            border-radius: 3px;
            background: #fe8124;
            color: #ffff;
        }

    @media all and (orientation: portrait)
        .post_d {
            padding-bottom: 10vh
            background #333
        }

        .inform-btn {
            width: .7rem;
            height: .3rem;
            color: #fe8124;
            border: 1px solid #ccc;
            line-height: .3rem;
            text-align: center;
            font-size: .245rem;
            vertical-align: middle;
            border-radius: 2px;
        }

        .comment-item {
            display: flex;
            flex-direction: row;
            color: white;
            margin-bottom: 0.333rem;
            border-bottom: 1px solid #797979;
        }

        .comments-head {
            color: white;
            display: flex;
            flex-direction: row;
            margin: 10px 0;
            padding: 10px 0;
            text-align: right;
            border-bottom: 1px solid #797979;
        }

        .comments-box {
            margin: 0 0.1rem 0.1rem 0.1rem;
        }


        .meta {
            font-size: 0.25rem;
        }

        .comment-avatar {
            height: 33px;
        }

        .comment-avatar img {
            border-radius: 100%
        }

        .content {
            margin-top: 0.15rem;
            font-size: 0.25rem;
            line-height: 0.3rem;
            word-wrap: break-word;
            white-space: pre-wrap;
            word-break: break-all;
        }

        .content p,.content p span{
            font-size: .28rem;
            color: #4c4c4c;
        }

        .reply-stat .time {
            display: inline-block;
            float: right;
        }

        .comment-content {
            padding-left: 10px;
            flex: 1 1 auto;
        }

        .reply-stat {
            display: flex;
            margin: 0.2rem 0;
            font-weight: 400;
        }

        .action-box {
            flex: 0 0 auto;
            display: flex;
            justify-content: space-between;
            margin-left: auto;
            min-width: 1.8rem;
            flex: .5
        }

        .comments-footer {
            overflow: hidden;
            display: flex;
            flex-direction: row;
            bottom: 0;
            width: 100%;
            background: #333;
            padding: 1vw;
        }

        .comments-footer input {
            height: 35px;
            line-height: 35px;
            border-radius: 3px;
            padding-left: 10px;
            color: #17181a;
            outline: none;
            min-height: 0.3em;
            flex: .97;
            margin-right: 20px;
        }

        .comments-footer button {
            height: 35px;
            line-height: 35px;
            width: 68px;
            border-radius: 3px;
            background: #d2a852;
            color: white;
        }
</style>
